import React from 'react';
import Button from '#lib/components/button.jsx';
import { Icon } from '@iconify-icon/react';
import { Link } from 'react-router-dom';

export default function CallTo() {
    return (
        <div className="relative p-3 h-full w-full overflow-hidden">
            <div className="absolute left-0 top-0 w-full h-full text-white overflow-hidden transition-all duration-300 ease-in-out">
                <Link className="w-fit absolute left-3 bottom-3 shadow-lg" to="/manage/itinerary/add">
                    <Button look="primary" type="submit">
                        <React.Fragment>
                            <span>{_t.home.callToBtn()}</span>
                        </React.Fragment>
                        <Icon icon="line-md:arrow-small-right" width="1.4rem" height="1.4rem" className="ml-2 pt-1" />
                    </Button>
                </Link>
            </div>
        </div>
    );
}
